import { Skeleton } from '@/components/ui/skeleton';

export const GallerySkeleton = () => {
    return (
        <div className="grid grid-cols-3 gap-4 md:gap-6">
            {Array.from({ length: 12 }).map((_, index) => (
                <Skeleton key={index} className="aspect-album w-full" />
            ))}
        </div>
    );
};
